import React from 'react'
import Image from "gatsby-image/withIEPolyfill"

const MeinImage = ({daten,bildtitel,alter}) => {
   
    return (
      <React.Fragment>
       
          <Image 
                fluid={daten}
                objectFit="cover"
                objectPosition="50% 50%"
                alt=""
             
                style={{
                  
                  margin:'3px'
                 
                }}
                imgStyle={{
                  borderRadius: `0`,
                }}
              /> 
              {bildtitel  &&
              <p style={{display:'block',color:'rgba(0,23,23,.61)',background:'rgba(122,122,122,.9)',textAlign:'center',padding:'4px 0'}}>{bildtitel}</p>
              }
      </React.Fragment>
  )


}
export default MeinImage  